import { fetchTaxPolicies } from '../api/taxPolicies';
import {
    BUSINESS_TAX_ADDRESS_COUNTRY_FIELD,
    IS_BUSINESS_FIELD,
} from '../middleware/constants';
import { checkTaxVATId } from './taxExemptions';

export const TAX_POLICIES_LOAD_COMPLETE = 'taxPoliciesLoadComplete';

export const taxPoliciesLoadSuccess = (response) => {
    const {
        tax_policies_container: [taxPolicies],
    } = response;

    let taxIdName;

    if (taxPolicies && taxPolicies.tax_id_name) {
        taxIdName = taxPolicies.tax_id_name;
    } else {
        taxIdName = null;
    }

    return {
        type: TAX_POLICIES_LOAD_COMPLETE,
        payload: taxIdName,
    };
};

/**
 * Wraps the `fetchTaxPolicies` endpoint
 *
 * @param dispatch
 * @returns {Promise.<*>}
 */

export const addressCountryChanged = (country) => async (
    dispatch,
    getState,
) => {
    const {
        form: {
            checkoutForm: { active },
        },
    } = getState();

    if (
        active === IS_BUSINESS_FIELD ||
        active === BUSINESS_TAX_ADDRESS_COUNTRY_FIELD
    ) {
        const { response } = await fetchTaxPolicies(country);

        dispatch(taxPoliciesLoadSuccess(response));
    }

    const { event: { hasTaxCountryExemptions = false } = {} } = getState();

    if (!hasTaxCountryExemptions) {
        return;
    }
    checkTaxVATId()(dispatch, getState);
};
